<template>
  <div>
    <div class="py-10">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" class="text-center">
            <div
              class="text-uppercase display-2 pa-6 hidden-sm-and-down"
              style="color: #2E3440;"
            >
              Appendix Print-Report
            </div>
            <div
              class="text-uppercase display-1 pa-6 hidden-md-and-up"
              style="color: #2E3440;"
            >
              Appendix Print-Report
            </div>

            <v-divider
              style="border-color: #7d9b38; border-width: 5px; width:50%; display: inline-block; border-style: dotted none none none"
            ></v-divider>

            <p class="title font-weight-light pa-6">
              Dies sind die Grafiken für den Print-Report
            </p>
          </v-col>
        </v-row>
      </v-container>
      <employeesComp></employeesComp>
      <ageComp></ageComp>
      <biascheck></biascheck>
      <digiChallenge></digiChallenge>
      <challengeDD1></challengeDD1>
      <challengeDD2></challengeDD2>
      <futureTechnologies></futureTechnologies>
      <useFutureTech></useFutureTech>
      <futureTechBySector></futureTechBySector>
      <useFutureTechDD1></useFutureTechDD1>
      <futureTechnologiesDD1></futureTechnologiesDD1>
      <cloudUse1></cloudUse1>
      <cloudUse2></cloudUse2>
      <cloudUse3></cloudUse3>
      <cloudUse4></cloudUse4>
      <a027></a027>
      <a028></a028>
      <a029></a029>
      <a030></a030>
      <a031></a031>
      <a032></a032>
      <a033></a033>
      <a034></a034>
      <a035></a035>
      <a037></a037>
      <a038></a038>
      <a039></a039>
      <a040></a040>
      <a041></a041>
      <a042></a042>
      <a043></a043>
      <a044></a044>
      <a046></a046>
      <a047></a047>
      <a048></a048>
      <a050></a050>
      <a051></a051>
      <a052></a052>
      <a053></a053>
      <a054></a054>
      <a055></a055>
      <a056></a056>
      <a057></a057>
      <a058></a058>
      <a059></a059>
      <a060></a060>
      <a061></a061>
      <a062></a062>
      <a063></a063>
      <a064></a064>
      <a065></a065>
      <a066></a066>
      <a067></a067>
    </div>
  </div>
</template>

<script>
import EmployeesComp from "@/components/annex/EmployeesComp.vue";
import AgeComp from "@/components/annex/AgeComp.vue";
import Biascheck from "@/components/annex/Biascheck.vue";
import DigiChallenge from "@/components/annex/DigiChallenge.vue";
import ChallengeDD1 from "@/components/annex/ChallengeDD1.vue";
import ChallengeDD2 from "@/components/annex/ChallengeDD2.vue";
import FutureTechnologies from "@/components/annex/FutureTechnologies.vue";
import UseFutureTech from "@/components/annex/UseFutureTech.vue";
import FutureTechBySector from "@/components/annex/FutureTechBySector.vue";
import UseFutureTechDD1 from "@/components/annex/UseFutureTechDD1.vue";
import FutureTechnologiesDD1 from "@/components/annex/FutureTechnologiesDD1.vue";
import CloudUse1 from "@/components/annex/CloudUse1.vue";
import CloudUse2 from "@/components/annex/CloudUse2.vue";
import CloudUse3 from "@/components/annex/CloudUse3.vue";
import CloudUse4 from "@/components/annex/CloudUse4.vue";
import A027 from "@/components/annex/A027.vue";
import A028 from "@/components/annex/A028.vue";
import A029 from "@/components/annex/A029.vue";
import A030 from "@/components/annex/A030.vue";
import A031 from "@/components/annex/A031.vue";
import A032 from "@/components/annex/A032.vue";
import A033 from "@/components/annex/A033.vue";
import A034 from "@/components/annex/A034.vue";
import A035 from "@/components/annex/A035.vue";
import A037 from "@/components/annex/A037.vue";
import A038 from "@/components/annex/A038.vue";
import A039 from "@/components/annex/A039.vue";
import A040 from "@/components/annex/A040.vue";
import A041 from "@/components/annex/A041.vue";
import A042 from "@/components/annex/A042.vue";
import A043 from "@/components/annex/A043.vue";
import A044 from "@/components/annex/A044.vue";
import A046 from "@/components/annex/A046.vue";
import A047 from "@/components/annex/A047.vue";
import A048 from "@/components/annex/A048.vue";
import A050 from "@/components/annex/A050.vue";
import A051 from "@/components/annex/A051.vue";
import A052 from "@/components/annex/A052.vue";
import A053 from "@/components/annex/A053.vue";
import A054 from "@/components/annex/A054.vue";
import A055 from "@/components/annex/A055.vue";
import A056 from "@/components/annex/A056.vue";
import A057 from "@/components/annex/A057.vue";
import A058 from "@/components/annex/A058.vue";
import A059 from "@/components/annex/A059.vue";
import A060 from "@/components/annex/A060.vue";
import A061 from "@/components/annex/A061.vue";
import A062 from "@/components/annex/A062.vue";
import A063 from "@/components/annex/A063.vue";
import A064 from "@/components/annex/A064.vue";
import A065 from "@/components/annex/A065.vue";
import A066 from "@/components/annex/A066.vue";
import A067 from "@/components/annex/A067.vue";

export default {
  components: {
    EmployeesComp,
    AgeComp,
    Biascheck,
    DigiChallenge,
    ChallengeDD1,
    ChallengeDD2,
    FutureTechnologies,
    UseFutureTech,
    FutureTechBySector,
    UseFutureTechDD1,
    FutureTechnologiesDD1,
    CloudUse1,
    CloudUse2,
    CloudUse3,
    CloudUse4,
    A027,
    A028,
    A029,
    A030,
    A031,
    A032,
    A033,
    A034,
    A035,
    A037,
    A038,
    A039,
    A040,
    A041,
    A042,
    A043,
    A044,
    A046,
    A047,
    A048,
    A050,
    A051,
    A052,
    A053,
    A054,
    A055,
    A056,
    A057,
    A058,
    A059,
    A060,
    A061,
    A062,
    A063,
    A064,
    A065,
    A066,
    A067
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #7d9b38;
  min-height: 20em;
}
.component-color {
  background-color: #eceff4;
}
</style>
